import {GeofenceEventEntity} from "@ots-frontend/ots-data";
import {EntityMarker, EntityMarkerProps} from "../../marker/EntityMarker/EntityMarker";
import { geofenceEventColor } from "../../../../theme/colors"

const MARKER_URI = `data:image/svg+xml,%3Csvg%20%20xmlns=%22http://www.w3.org/2000/svg%22%20%20width=%2224%22%20%20height=%2224%22%20%20viewBox=%220%200%2024%2024%22%20%20fill=%22none%22%20%20stroke=%22${geofenceEventColor.replace("#", "%23")}%22%20%20stroke-width=%222%22%20%20stroke-linecap=%22round%22%20%20stroke-linejoin=%22round%22%20%20class=%22icon%20icon-tabler%20icons-tabler-outline%20icon-tabler-radar%22%3E%3Cpath%20stroke=%22none%22%20d=%22M0%200h24v24H0z%22%20fill=%22none%22/%3E%3Cpath%20d=%22M21%2012h-8a1%201%200%201%200%20-1%201v8a9%209%200%200%200%209%20-9%22%20/%3E%3Cpath%20d=%22M16%209a5%205%200%201%200%20-7%207%22%20/%3E%3Cpath%20d=%22M20.486%209a9%209%200%201%200%20-11.482%2011.495%22%20/%3E%3C/svg%3E`

export type GeofenceEventMarkersProps = Omit<EntityMarkerProps<GeofenceEventEntity>, 'entity' | 'position' | 'options' | 'icon'> & {
  geofenceEvents: GeofenceEventEntity[];
}

export const GeofenceEventMarkers = (props: GeofenceEventMarkersProps) => {
  const {geofenceEvents, ...rest} = props


  return (
    <>
      {geofenceEvents.map((geofenceEvent) => {
        return (
          <EntityMarker
            {...rest}
            key={geofenceEvent.id}
            entity={geofenceEvent}
            position={{
              lat: geofenceEvent.coordinates!.latCoord,
              lng: geofenceEvent.coordinates!.longCoord,
            }}
            icon={{
              url: MARKER_URI,
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(-5, 24),
            }}
          />
        )
      })}
    </>
  )
}
